import React from 'react'

import { Context } from 'types/GlobalUserEvents'
import { SxProps } from '@mui/material'
import { TResource } from 'types/GlobalResource'

import { useReportEditionActions } from 'redux/actions/ReportEditions'
import { useReport, useReportEditions } from 'redux/hooks/Reports'
import { useTranslation } from 'language/translator'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'

import ResourcesTable from 'components_new/organisms/ResourcesTable'

import { getThumbnail } from 'utils/functions'
import Button from 'components_new/atoms/Button'
import { useHistory } from 'react-router-dom'

interface ReportEditionsTableProps {
  editMode?: boolean
  preview?: boolean
  reportId: string
  sx?: SxProps
}

const ReportEditionsTable = (props: ReportEditionsTableProps) => {
  const { editMode, preview, reportId, sx } = props

  const editions = useReportEditions(reportId)
  const history = useHistory()
  const report = useReport(reportId)
  const { t } = useTranslation()
  const { tryCreateReportEdition } = useReportEditionActions()

  const loading = !report

  const handleAddEdition = () => {
    tryCreateReportEdition({ report_id: reportId }, (newEditionId) =>
      history.push(`/reports/${reportId}/editions/${newEditionId}?edit=true`)
    )
  }

  const resources: TResource[] = editions.map((edition) => {
    return {
      edition: true,
      href: `/reports/${reportId}/editions/${edition.id}`,
      id: edition.id,
      // owner // $TODO
      src: getThumbnail(report?.thumbnail ?? null),
      status: edition.status,
      title: edition.title ?? '', // $TODO
      updatedAt: edition.updated_at,
      variant: 'report'
      // visitedAt // $TODO
    }
  })

  if (editions.length === 0)
    return (
      <EmptyPlaceholder
        actions={
          <Button onClick={handleAddEdition}>
            {t('global', 'create')} {t('global', 'edition', true)}
          </Button>
        }
        background={true}
        body={t('reports', 'empty_editions_body')}
        height={preview ? 172 : undefined}
        size="small"
        sx={sx}
        title={t('reports', 'empty_editions_title')}
      />
    )

  return (
    <ResourcesTable
      context={Context.FROM_REPORT_EDITIONS_PAGE}
      editMode={editMode}
      items={resources}
      loading={loading}
      onClickAdd={handleAddEdition}
      preview={preview}
      searchPlaceholder={`${t('global', 'search')} ${t(
        'global',
        'edition',
        true
      )}`}
      sx={sx}
      viewAllHref={`/reports/${reportId}/editions`}
    />
  )
}

export default ReportEditionsTable
